import { Table } from '@tanstack/react-table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button, Icon } from '@/components';

interface DataTablePaginationProps<TData> {
  table: Table<TData>;
}

export function DataTablePagination<TData>({ table }: DataTablePaginationProps<TData>) {
  return (
    <div className="mt-6 mb-6 flex items-center justify-end">
      <div className="flex items-center space-x-2">
        <div className="flex items-center space-x-2">
          <p className="text-sm font-medium">Rows per page</p>
          <Select
            value={`${table.getState().pagination.pageSize}`}
            onValueChange={(value: any) => {
              table.setPageSize(Number(value));
            }}
          >
            <SelectTrigger className="dark:focus-visible:ring-primary-100 focus-visible:border-primary-700 h-8 w-[70px] bg-white">
              <SelectValue placeholder={table.getState().pagination.pageSize} />
            </SelectTrigger>
            <SelectContent
              side="top"
              className="dark:focus-visible:ring-primary-100 focus-visible:border-primary-700 bg-white"
            >
              {[10, 20, 25, 30, 40, 50].map((pageSize) => (
                <SelectItem key={pageSize} value={`${pageSize}`}>
                  {pageSize}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex w-[100px] items-center justify-center text-sm font-medium">
          Page {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
        </div>

        <div className="flex items-end space-x-2">
          <Button
            className="bg-neutral-25 hidden enabled:hover:bg-neutral-50 lg:flex"
            onClick={() => table.setPageIndex(0)}
            disabled={!table.getCanPreviousPage()}
            color="neutral"
          >
            <span className="sr-only">Go to first page</span>
            <Icon name="chevrons-left" className="h-4 w-4" />
          </Button>
          <Button color="neutral" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
            <span className="sr-only">Go to previous page</span>
            <Icon name="chevron-left" className="h-4 w-4" />
          </Button>
          <Button color="neutral" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
            <span className="sr-only">Go to next page</span>
            <Icon name="chevron-left" className="h-4 w-4 rotate-180" />
          </Button>
          <Button
            className="bg-neutral-25 mr-2 hidden enabled:hover:bg-neutral-50 lg:flex"
            color="neutral"
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={!table.getCanNextPage()}
          >
            <span className="sr-only">Go to last page</span>
            <Icon name="chevrons-left" className="h-4 w-4 rotate-180" />
          </Button>
        </div>
      </div>
    </div>
  );
}
